<template>
  <div style="height: 100%;">
    <div class="whaty-grid" v-loading="loading" v-if="!historyVisible"  :element-loading-text="loadingText">
      <crumbs-nav></crumbs-nav>
      <transition
        @enter="handleEnter"
        @leave="handleLeave"
        :css="false">
        <grid-search-form
          ref="searchForm"
          v-show="showSearchForm"
          v-if="gridConfig.canSearch"
          :gridConfig="gridConfig"
          :gridConfigUrl="myGridConfigUrl"
          @on-search="handleSearch"
        ></grid-search-form>
      </transition>
      <div v-show="!showChart">
        <grid-top-operation
          ref="topOperation"
          :pageSize="page.pageSize"
          :curPage="page.curPage"
          :gridConfig="gridConfig"
          :checkedRows="checkedRows"
          :showSearchForm="showSearchForm"
          :totalCount="page.totalCount"
          :selectAllRows="selectAllRows"
          :updateColumnUrl="updateColumnUrl"
          :menus="topMenus"
          @clear-check-row="handleClearCheckRow"
          @select-all-row="handleSelectAllRow"
          @toggle-search-form="handleToggleSearchForm"
          @toggle-column-show="handleToggleColumnShow"
          @toggle-column-fix="handleToggleColumnFix"
          @show-all-column="handleShowAllColumn"
          @hide-all-column="handleHideAllColumn"
          @menu-click="handleMenuClick"
          @add-button-click="handleAddButtonClick"
          @delete-button-click="handleDeleteButtonClick"
          @import="handleImport"
        >
          <template slot="topNoSelectMenus">
            <slot name="topNoSelectMenus" :magicalMenuCodes="magicalMenuCodes"></slot>
          </template>
          <template slot="topSelectMenus">
            <slot name="topSelectMenus" :ids="getSelectIds" :magicalMenuCodes="magicalMenuCodes"></slot>
          </template>
        </grid-top-operation>
        <grid-table
          ref="gridTable"
          :gridConfig="gridConfig"
          :tableData="page.items"
          :tableDisplayData="displayItems"
          :startIndex="(page.curPage - 1) * page.pageSize + 1"
          :tBodyHeight="tBodyHeight"
          :menus="columnMenus"
          :magicalMenuCodes="magicalMenuCodes"
          :tableColumnWidthMap="tableColumnWidthMap"
          :tableMenuWidthMap="tableMenuWidthMap"
          @checked-row-change="handleCheckedRowChange"
          @order-item-change="handleOrderItemChange"
          @menu-click="handleMenuClick"
          @row-dblclick="handleRowDblClick"
          @showChangeHistory="showChangeHistory"
        >
          <template slot="headerColumns">
            <slot name="headerColumns" :magicalMenuCodes="magicalMenuCodes"></slot>
          </template>
          <template slot="bodyColumns" slot-scope="props" >
            <slot name="bodyColumns" :row="props.row" :magicalMenuCodes="magicalMenuCodes"></slot>
          </template>
          <template slot="lastHeaderColumns">
            <slot name="lastHeaderColumns" :magicalMenuCodes="magicalMenuCodes"></slot>
          </template>
          <template slot="lastBodyColumns" slot-scope="props" >
            <slot name="lastBodyColumns" :row="props.row" :magicalMenuCodes="magicalMenuCodes"></slot>
          </template>
        </grid-table>
      </div>
      <div v-if="showChart && gridConfig.chartCode"
           class="grid-chart"
           :style="{height: gridChartHeight + 'px', display: 'flex', 'align-items': 'center'}">
        <whaty-chart
          ref="gridChart"
          :chartCode="gridConfig.chartCode"
          :chartData="page.items"
        ></whaty-chart>
      </div>
      <grid-footer
        ref="gridFooter"
        :curPage="page.curPage"
        :pageSize="page.pageSize"
        :totalPage="page.totalPage"
        :totalCount="page.totalCount"
        :pageSizeOpts="page.pageSizeOpts"
        :showChartIcon="!!gridConfig.chartCode"
        :showChart="showChart"
        :magicalMenuCodes="magicalMenuCodes"
        :gridConfig="gridConfig"
        @current-change="onPageNoChange"
        @size-change="onPageSizeChange"
        @export="handleExport"
        @toggle-chart="handleToggleChart"
      ></grid-footer>
    </div>
    <data-history-draw ref="draw" @close="closeChangeHistory"
                       v-if="historyVisible"
                       :id="historyDrawId"
                       :namespace="historyNamespace"
                       :currentData="historyDrawCurrentData"
    ></data-history-draw>

    <form ref="hiddenForm" :action="hiddenFormAction" :target="hiddenFormTarget" method="post" style="display: none;">
      <input v-for="item in hiddenFormParameters" :name="item.name" :value="item.value" type="hidden">
    </form>

    <dialog-form
      ref="gridEditDialogForm"
      :formConfig="formConfig"
      @submit-success="handleAddSuccess"
      @change-router="handleChangeRouter"
    ></dialog-form>

    <grid-export
     ref="gridExportRef"
     :gridConfig="gridConfig"
     :gridParams="params"
     :pageSize="page.pageSize"
     :curPage="page.curPage"
     :totalCount="page.totalCount"
     :orderItem="page.orderItem"
     :selectRow="checkedRows.length"
    ></grid-export>

    <grid-import
      ref="gridImportRef"
      :importConfig="gridImportConfig"
      @finish="handleImportFinish"
    ></grid-import>

    <excel-import-simple
      ref="simpleImportRef"
      :importConfig="importConfig"
      :checkedRows="checkedRows"
      @close="handleSimpleImportClose"
    ></excel-import-simple>

    <drawer-form
      ref="gridDrawerFormRef"
      :formConfig="formConfig"
      :formCmpName="gridConfig.addCmpName"
      @submit-success="handleAddSuccess"
      @change-router="handleChangeRouter"
    ></drawer-form>
  </div>
</template>
<script>
  import { addResizeListener, removeResizeListener } from 'element-ui/src/utils/resize-event'
  import GridSearchForm from './grid-search-form.vue'
  import GridTopOperation from './grid-top-operation.vue'
  import GridTable from './grid-table.vue'
  import GridFooter from './grid-footer.vue'
  import util from '../../libs/util'
  import WhatyDialog from '../dialog/dialog.vue'
  import DialogForm from './dialog-form.vue'
  import gridExport from './grid-export'
  import ExcelImportSimple from '../excel-import/excel-import-simple.vue'
  import GridImport from './grid-import.vue'
  import CrumbsNav from '../crumbs-nav/crumbs-nav'
  import DrawerForm from './drawer-form'
  import WhatyChart from '../whaty-charts/whaty-chart'
  import Velocity from 'velocity-animate'
  import DataHistoryDraw from '../record/data-history-draw'

  export default {
    components: {
      WhatyChart,
      DrawerForm,
      CrumbsNav,
      GridImport,
      ExcelImportSimple,
      DialogForm,
      WhatyDialog,
      GridSearchForm,
      GridTopOperation,
      GridTable,
      GridFooter,
      gridExport,
      DataHistoryDraw
    },
    name: 'grid',
    props: {
      gridConfigUrl: {
        type: String,
        require: true
      },
      gridMenuList: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        copyRoute: {},
        searchFormActive: false, // form动画是否激活，第一次加载form时不显示动画
        loading: true,
        loadingText: '数据加载中，请稍候...',
        gridConfig: {}, // grid配置
        page: { // 分页组件配置
          pageSizeOpts: [10, 20, 50, 100], // 每页条数切换配置
          placement: 'top', // 条数切换配置展开方向
          showTotal: true, // 显示总数
          showElevator: true, // 显示电梯
          showSizer: true, // 显示分页
          curPage: 1, // 当前页
          pageSize: 20, // 页大小
          totalPage: 0, // 总页数
          totalCount: 0, // 记录总数
          orderBy: '',
          orderType: '',
          orderItem: [], // 多列排序
          items: [] // 数据
        },
        displayItems: [], // 存放列显示的内容
        selectAllRows: false, // 选中全部筛选结果标示
        checkedRows: [], // 选中的行
        elOffsetHeight: 0, // grid高度记录
        elSearchFormHeight: 0, // searchForm高度记录
        elToolbarHeight: 0, // 操作按钮高度记录
        tBodyHeight: 200,
        gridChartHeight: 200,
        showSearchForm: true, // 是否显示search form
        hiddenFormAction: '',
        hiddenFormTarget: '',
        hiddenFormParameters: [],
        topMenus: [],
        columnMenus: [],
        // form表单配置
        formConfig: {
          fields: []
        },
        importConfig: {}, // 简单导入功能的配置
        gridImportConfig: {}, // grid导入功能配置
        isFirstLoadData: true, // 是否第一次加载表格数据,
        tableColumnMaxWidth: 300, // 表格列最大宽度
        tableColumnWidthMap: {}, // 表格列宽
        tableMenuWidthMap: {}, // 菜单宽度
        showChart: false, // 是否显示图表
        historyVisible: false,
        historyDrawId: null,
        historyDrawCurrentData: {},
        historyNamespace: null
      }
    },
    computed: {
      myGridConfigUrl: function () {
        // 如果菜单配置了gridId，则把gridId放到gridConfigUrl中
        let menuGridId = this.copyRoute.meta.gridId
        if (menuGridId) {
          let reg = /actionId=[^&]*/
          if (reg.test(this.gridConfigUrl)) {
            return this.gridConfigUrl.replace(reg, 'actionId=' + menuGridId)
          } else if (this.gridConfigUrl.indexOf('?') !== -1) {
            return this.gridConfigUrl + '&actionId=' + menuGridId
          } else {
            return this.gridConfigUrl + '?actionId=' + menuGridId
          }
        }
        return this.gridConfigUrl
      },
      gridId: function () {
        return ''
      },
      listUrl: function () {
        if (this.myGridConfigUrl) {
          return this.myGridConfigUrl.replace('abstractGrid', 'abstractList')
        }
        return ''
      },
      abstractAddUrl: function () {
        if (this.myGridConfigUrl) {
          return this.myGridConfigUrl.replace('abstractGrid', 'abstractAdd')
        }
        return ''
      },
      updateUrl: function () {
        if (this.myGridConfigUrl) {
          return this.myGridConfigUrl.replace('abstractGrid', 'abstractUpdate')
        }
        return ''
      },
      abstractDetailUrl: function () {
        if (this.myGridConfigUrl) {
          return this.myGridConfigUrl.replace('abstractGrid', 'abstractDetail')
        }
        return ''
      },
      selectDataUrl: function () {
        if (this.myGridConfigUrl) {
          return this.myGridConfigUrl.replace('abstractGrid', 'selectData')
        }
        return ''
      },
      updateColumnUrl: function () {
        if (this.myGridConfigUrl) {
          return this.myGridConfigUrl.replace('abstractGrid', 'abstractUpdateColumn')
        }
        return ''
      },
      getSelectIds: function () {
        let ids = []
        let selectedRows = this.getSelectedRows()
        for (let i = 0; i < selectedRows.length; i++) {
          ids.push(util.getAttribute(selectedRows[i], 'id'))
        }
        return ids.join(',')
      },
      abstractDeleteUrl: function () {
        if (this.myGridConfigUrl) {
          return this.myGridConfigUrl.replace('abstractGrid', 'abstractDelete')
        }
        return ''
      },
      // 下载excel批量导入模板的地址
      downloadExcelTemplateUrl: function () {
        if (this.myGridConfigUrl) {
          return this.myGridConfigUrl.replace('abstractGrid', 'abstractDownloadExcelTemplate')
        }
        return ''
      },
      // 上传excel的地址
      uploadExcelUrl: function () {
        if (this.myGridConfigUrl) {
          return this.myGridConfigUrl.replace('abstractGrid', 'abstractUploadExcel')
        }
        return ''
      },
      // 开始进行excel导入的地址
      startImportExcelUrl: function () {
        if (this.myGridConfigUrl) {
          return this.myGridConfigUrl.replace('abstractGrid', 'abstractStartExcelImport')
        }
        return ''
      },
      // 下载excel导入的错误信息的url
      downloadExcelErrorInfoUrl: function () {
        if (this.myGridConfigUrl) {
          return this.myGridConfigUrl.replace('abstractGrid', 'abstractDown')
        }
        return ''
      },
      params: function () {
        let params = {}
        // 把myGridConfigUrl中的路径参数添加到params
        if (this.myGridConfigUrl) {
          let urlParams = this.myGridConfigUrl.split('?')
          if (urlParams.length > 1) {
            let pArr = urlParams[1].split('&')
            for (let i = 0; i < pArr.length; i++) {
              let keyValue = pArr[i].split('=')
              params[keyValue[0]] = keyValue[1]
            }
          }
        }
        // 把路由中的query参数添加到params
        params = {...params, ...this.copyRoute.query}
        return params
      },
      checkedRowsFullData: function () { // 有自定义grid使用这个方法
        let data = []
        if (this.checkedRows.length > 0) {
          for (let i = 0; i < this.page.items.length; i++) {
            for (let j = 0; j < this.checkedRows.length; j++) {
              if (this.page.items[i].id === this.checkedRows[j]) {
                data.push(this.page.items[i])
              }
            }
          }
        }
        return data
      },
      magicalMenuCodes: function () {
        let codeArr = []
        if (this.gridConfig.gridMenuList && this.gridConfig.gridMenuList.length > 0) {
          this.gridConfig.gridMenuList.forEach(menu => {
            if (menu.type === 'magicalMenu') {
              let menuExtendConfig = this.getMenuExtendConfig(menu)
              if (menuExtendConfig && menuExtendConfig.code) {
                codeArr.push(menuExtendConfig.code)
              }
            }
          })
        }
        return codeArr
      }
    },
    created() {
      this.initCopyRoute()
      this.initGrid()
      this.initMenus()
    },
    mounted() {
      this.$nextTick(this.computeHeight)
      addResizeListener(this.$el, this.gridResizeListener)
    },
    beforeDestroy() {
      removeResizeListener(this.$el, this.gridResizeListener)
    },
    methods: {
      initCopyRoute() {
        this.copyRoute = this.$route
      },
      handleEnter(el, done) {
        if (this.searchFormActive) {
          Velocity(el, 'slideDown', {
            duration: 200,
            begin: () => {
              Velocity(this.$refs.gridTable.$el, {height: this.$refs.gridTable.$el.offsetHeight - el.offsetHeight}, {duration: 200})
            },
            complete: () => {
              this.computeHeight()
              done()
            }
          })
        } else {
          this.searchFormActive = true
          done()
        }
      },
      handleLeave(el, done) {
        Velocity(el, 'slideUp', {
          duration: 200,
          begin: () => {
            this.tBodyHeight += el.offsetHeight
            Velocity(this.$refs.gridTable.$el, {height: this.$refs.gridTable.$el.offsetHeight + el.offsetHeight}, {duration: 200})
          },
          complete: () => {
            this.computeHeight()
            done()
          }
        })
      },
      initGrid() { // 从服务器获取grid配置
        util.ajax.post(this.myGridConfigUrl, {params: this.params}).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.gridConfig = res.data.data
            this.$emit('grid-config-ready')
            this.loadTableData()
          } else {
            this.$notify.info({title: '提示', message: '获取列表配置失败：' + res.data.meta.errMsg})
            this.loading = false
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '获取列表配置失败'})
          console.error(err)
          this.loading = false
        })
      },
      initMenus() {
        this.initTopMenus()
        this.initColumnMenus()
      },
      initTopMenus() {
        if (this.gridMenuList) {
          for (let i = 0; i < this.gridMenuList.length; i++) {
            if (this.gridMenuList[i].layout === 'top') {
              this.topMenus.push(this.gridMenuList[i])
            }
          }
        }
      },
      initColumnMenus() {
        if (this.gridMenuList && this.gridMenuList.length > 0) {
          for (let i = 0; i < this.gridMenuList.length; i++) {
            if (this.gridMenuList[i].layout === 'column') {
              this.columnMenus.push(this.gridMenuList[i])
            }
          }
        }
      },
      loadTableData() { // 加载列表数据
        this.loading = true
        let params = {}
        params.params = this.params
        params.page = {
          'curPage': this.page.curPage,
          'pageSize': this.page.pageSize,
          'orderItem': this.page.orderItem
        }
        if (this.$refs.searchForm) {
          params.page.searchItem = this.processSearchParams()
        }
        util.ajax.post(this.listUrl, params).then((res) => {
          this.page.pageSize = res.data.data.pageSize
          this.page.curPage = res.data.data.curPage
          this.page.totalCount = res.data.data.totalCount
          this.page.totalPage = res.data.data.totalPage
          this.page.items = res.data.data.items
          this.loading = false
          if (this.isFirstLoadData) {
            this.afterFirstLoadData()
            this.isFirstLoadData = false
            this.$nextTick(this.computeHeight)
          }
          // 搜索结果高亮
          this.getDisplayItems()
          this.$refs.gridTable.handleScroll()
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '加载数据失败'})
          console.error(err)
          this.loading = false
        })
        this.handleClearCheckRow() // load完数据，清空checkedRows
      },
      afterFirstLoadData() { // 第一次加载数据时的事件
        // 保存isHtml的初始值
        for (let i = 0; i < this.gridConfig.listColumnConfig.length; i++) {
          let col = this.gridConfig.listColumnConfig[i]
          if (col.originalIsHtml === undefined) {
            this.$set(col, 'originalIsHtml', !!col.isHtml)
          }
        }
        this.calculateTableColumnWidthMap()
        this.calculateTableMenuWidthMap()
      },
      calculateTableColumnWidthMap() { // 计算table列宽
        let fontSize = '12px'
        if (this.gridConfig.listColumnConfig) {
          for (let i = 0; i < this.gridConfig.listColumnConfig.length; i++) {
            let col = this.gridConfig.listColumnConfig[i]
            if (!col.list) {
              continue
            }
            // 加20的padding,加16的排序图标的位置
            let colWidth = util.getTextDisplayWidth(col.name, fontSize) + 20 + 16
            if (this.page.items) {
              for (let j = 0; j < this.page.items.length; j++) {
                let obj = this.page.items[j]
                let colValue = util.getAttribute(obj, col.dataIndex, col)
                // 如果col是html,则计算去掉html后的长度
                if (col.isHtml) {
                  colValue = util.clearHtml(colValue)
                }
                let colValueWidth = util.getTextDisplayWidth(colValue, fontSize) + 20 + 16
                if (colValueWidth > colWidth) {
                  colWidth = colValueWidth
                }
              }
            }
            this.tableColumnWidthMap[col.dataIndex] = colWidth > this.tableColumnMaxWidth ? this.tableColumnMaxWidth : colWidth
          }
        }
      },
      calculateTableMenuWidthMap() {
        let fontSize = '12px'
        if (this.gridConfig.gridMenuList) {
          for (let i = 0; i < this.gridConfig.gridMenuList.length; i++) {
            let menu = this.gridConfig.gridMenuList[i]
            if (menu.showType === 'column') {
              let menuWidth = util.getTextDisplayWidth(menu.text, fontSize) + 20
              let oldWidth = this.tableMenuWidthMap[menu.text] || 20
              this.tableMenuWidthMap[menu.text] = menuWidth > oldWidth ? menuWidth : oldWidth
            }
          }
        }
      },
      getDisplayItems() { // 获取displayItems。设置高亮
        let searchItem = this.processSearchParams()
        this.displayItems = []
        if (this.page.items) {
          for (let i = 0; i < this.page.items.length; i++) {
            let obj = this.page.items[i]
            let displayRow = {}
            for (let j = 0; j < this.gridConfig.listColumnConfig.length; j++) {
              let col = this.gridConfig.listColumnConfig[j]
              let query = searchItem ? searchItem[col.dataIndex] : ''
              let colValue = util.getAttribute(obj, col.dataIndex, col)
              if (query && query.trim()) {
                query = query.trim()
                if (colValue) {
                  colValue = colValue + '' // 将colValue转为String类型
                  if (col.originalIsHtml) {
                    let value = colValue.replace(/<[^>]*>|/g, '') // 去掉原有html样式，获取纯文本
                    if (util.indexOfIgnoreCase(value, query) !== -1) {
                      let newValue = value.replace(query, '<span class="red">' + query + '</span>') // 替换出文本中关键字高亮
                      colValue = colValue.replace(value, newValue) // 替换原值中纯文本
                      this.$set(col, 'isHtml', true)
                    } else {
                      this.$set(col, 'isHtml', col.originalIsHtml)
                    }
                  } else {
                    if (util.indexOfIgnoreCase(colValue, query) !== -1) {
                      let escapeColValue = util.html2Escape(colValue)
                      let escapeQuery = util.html2Escape(query)
                      colValue = escapeColValue.replace(escapeQuery, '<span class="red">' + escapeQuery + '</span>') // 替换出文本中关键字高亮
                      this.$set(col, 'isHtml', true)
                    } else {
                      this.$set(col, 'isHtml', col.originalIsHtml)
                    }
                  }
                }
              } else {
                this.$set(col, 'isHtml', col.originalIsHtml)
              }
              // if (query && colValue.indexOf(query) !== -1) {
              //   let value = colValue.replace(/<[^>]*>|/g, '') // 去掉原有html样式，获取纯文本
              //   let newValue = value.replace(query, '<span class="red">' + query + '</span>') // 替换出文本中关键字高亮
              //   colValue = colValue.replace(value, newValue) // 替换原值中纯文本
              //   this.$set(col, 'isHtml', true)
              // } else {
              //   this.$set(col, 'isHtml', col.originalIsHtml)
              // }
              displayRow[col.dataIndex] = colValue
            }
            this.displayItems.push(displayRow)
          }
        }
      },
      processSearchParams() { // 处理搜索参数,符合后台格式
        if (this.gridConfig.canSearch) {
          let {...sp} = this.$refs.searchForm.searchParams
          for (let i = 0; i < this.gridConfig.listColumnConfig.length; i++) {
            let column = this.gridConfig.listColumnConfig[i]
            if (column.search && sp[column.dataIndex]) {
//            if (column.type === 'select') {
//              let newValue = ''
//              for (let j = 0; j < sp[column.dataIndex].length; j++) {
//                newValue += sp[column.dataIndex][j]
//                if (j < sp[column.dataIndex].length - 1) {
//                  newValue += ' or '
//                }
//              }
//              sp[column.dataIndex] = newValue
//            }
              // 转换日期搜索参数格式
              if (column.type === 'date' || column.type === 'datetime') {
                let newValue = ''
                newValue = ' >= ' + sp[column.dataIndex][0] + ' and <= ' + sp[column.dataIndex][1]
                sp[column.dataIndex] = newValue
              }
            }
          }
          return sp
        }
      },
      onPageNoChange(curPage) {
        if (this.page.curPage !== curPage) {
          this.$refs.gridTable.clearRowChecks()
          this.page.curPage = curPage
          this.loadTableData()
        }
      },
      onPageSizeChange(pageSize) {
        if (this.page.pageSize !== pageSize) {
          this.$refs.gridTable.clearRowChecks()
          this.page.curPage = 1
          this.page.pageSize = pageSize
          this.loadTableData()
        }
      },
      handleCheckedRowChange(checkedRows) {
        // 如果选择全部数据数量小于totalCount，更新是否选择全部筛选结果标示
        if ((this.page.totalCount > this.page.pageSize ? this.page.pageSize : this.page.totalCount) > checkedRows.length) {
          this.selectAllRows = false
        }
        this.checkedRows = checkedRows
      },
      handleClearCheckRow() { // 取消选择
        this.$refs.gridTable.clearRowChecks()
        this.selectAllRows = false
      },
      handleSelectAllRow() { // 选中全部筛选结果
        this.$refs.gridTable.selectAllRow()
        this.selectAllRows = true
      },
      computeHeight() {
        this.updateTBodyAndChartHeight()
      },
      updateTBodyAndChartHeight() {
        let crumbsNavHeight = this.copyRoute.meta.menu && this.copyRoute.meta.menu.showInLeftMenu !== '1' ? 28 : 0
        let searchFormHeight = 0
        if (this.showSearchForm && this.$refs.searchForm) {
          searchFormHeight = this.$refs.searchForm.$el.offsetHeight
        }
        let gridFooterHeight = this.$refs.gridFooter ? this.$refs.gridFooter.$el.offsetHeight : 0
        let topOperationHeight = this.$refs.topOperation ? this.$refs.topOperation.$el.offsetHeight : 0
        // let tableHeadHeight = 31
        this.tBodyHeight = this.$el.offsetHeight - gridFooterHeight - crumbsNavHeight - searchFormHeight - topOperationHeight
        // set chart height
        this.gridChartHeight = this.tBodyHeight + topOperationHeight
      },
      handleSearch() { // 搜索
        this.page.curPage = 1
        this.loadTableData()
      },
      handleToggleSearchForm() { // 切换search form显示/隐藏
        this.showSearchForm = !this.showSearchForm
      },
      handleOrderItemChange(orderItem) { // 列排序
        this.page.orderItem = orderItem
        this.loadTableData()
      },
      handleToggleColumnShow(column) { // 切换列的隐藏/显示
        for (let i = 0; i < this.gridConfig.listColumnConfig.length; i++) {
          if (this.gridConfig.listColumnConfig[i].dataIndex === column.dataIndex) {
            this.$set(this.gridConfig.listColumnConfig[i], 'show', !(column.show === undefined || column.show === true))
            break
          }
        }
      },
      handleToggleColumnFix(column) { // 切换列冻结状态
        let count = 0
        let columnIndex
        for (let i = 0; i < this.gridConfig.listColumnConfig.length; i++) {
          // 记录当前已经冻结列数
          if (this.gridConfig.listColumnConfig[i].fix === 'left') {
            count++
          }
          // 查找column对应的index
          if (this.gridConfig.listColumnConfig[i].list && this.gridConfig.listColumnConfig[i].dataIndex === column.dataIndex) {
            columnIndex = i
          }
        }
        if (!column.fix) {
          // 如果要设置为冻结列,判断当前已经冻结的列数是否大于5列
          if (count > 5) {
            this.$notify.warning({title: '警告', message: '最多允许冻结6列'})
            return
          }
          this.$set(this.gridConfig.listColumnConfig[columnIndex], 'fix', 'left')
        } else {
          this.$set(this.gridConfig.listColumnConfig[columnIndex], 'fix', '')
        }
      },
      handleShowAllColumn() { // 显示全部列
        for (let i = 0; i < this.gridConfig.listColumnConfig.length; i++) {
          this.$set(this.gridConfig.listColumnConfig[i], 'show', true)
        }
      },
      handleHideAllColumn() { // 隐藏全部列
        for (let i = 0; i < this.gridConfig.listColumnConfig.length; i++) {
          this.$set(this.gridConfig.listColumnConfig[i], 'show', false)
        }
      },
      getSelectedRows() { // 获取选中的行
        let selectedRows = []
        for (let i = 0; i < this.page.items.length; i++) {
          for (let j = 0; j < this.checkedRows.length; j++) {
            if (this.checkedRows[j] === this.page.items[i].id) {
              selectedRows.push(this.page.items[i])
            }
          }
        }
        return selectedRows
      },
      handleMenuClick(menu, id, row) { // 点击menu处理方法
        if (menu.type === 'ajaxMenu') {
          this.handleAjaxMenu(menu, id, row)
        } else if (menu.type === 'toUrlMenu') {
          this.handleToUrlMenu(menu, id)
        } else if (menu.type === 'formMenu') {
          this.handleFormMenu(menu, id)
        } else if (menu.type === 'updateColumnMenu') {
          this.handleUpdateColumnMenu(menu, id)
        } else if (menu.type === 'simpleImportMenu') {
          this.handleSimpleImportMenu(menu, id)
        } else if (menu.type === 'changeRouterMenu') {
          this.handleChangeRouterMenu(menu, id, row)
        } else if (menu.type === 'backMenu') {
          this.handleBackMenu(menu, id)
        } else if (menu.type === 'messageMenu') {
          this.handleMessageMenu(menu, id)
        } else {
          this.$notify.warning({title: '警告', message: '无效的菜单类型'})
        }
      },
      handleAjaxMenu(menu, id, row) {
        if (menu.mustSelectRow && !this.checkSelect(menu)) {
          return
        }
        if (menu.showConfirm) {
          this.$confirm(menu.confirmText || '您确定要执行此操作吗？', '确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.ajaxMenu(menu, id, row)
          }).catch((err) => {
            console.log(err)
          })
        } else {
          this.ajaxMenu(menu, id, row)
        }
      },
      ajaxMenu(menu, id, row) {
        let ids = menu.showType === 'column' ? id : this.getIds(menu).join(',')
        let url = menu.requestConfig.url
        let requestParams = {}
        let params = {}
        params = {
          ids: ids,
          ...menu.requestConfig.extraParameters,
          ...this.params,
          'actionId': this.gridConfig.gridId
        }
        // 获取extendConfig中的动态参数
        params = {...params, ...this.getMenuRowParams(menu, row)}
        requestParams.params = params
        if (this.selectAllRows) {
          requestParams.page = {
            'curPage': this.page.curPage,
            'pageSize': this.page.pageSize,
            'orderItem': [],
            'totalCount': this.page.totalCount
          }
          if (this.$refs.searchForm) {
            requestParams.page.searchItem = this.processSearchParams()
          }
        }
        this.loading = true
        let defaultLoadingText = this.loadingText
        this.loadingText = menu.requestConfig && menu.requestConfig.waitingMsg ? menu.requestConfig.waitingMsg : '操作中，请稍候...'
        util.ajax.post(url, requestParams).then((res) => {
          this.loading = false
          this.loadingText = defaultLoadingText
          if (res.data.meta.errCode === 0) {
            let msg = res.data.meta.errMsg || menu.requestConfig.successMsg || '操作成功！'
            this.$notify.success({title: '成功', message: msg === 'ok' ? '操作成功' : msg})
            this.loadTableData()
            try{
              if(res.data.data["jumpUrl"]){
                window.open(res.data.data["jumpUrl"],"_blank");
                return;
              }
            }catch(e){

            }
          } else {
            this.$notify.warning({title: '警告', message: res.data.meta.errMsg || menu.requestConfig.errorMsg || '操作失败！'})
          }
        }).catch((err) => {
          console.error(err)
          this.$notify.error({title: '错误', message: '操作失败'})
          this.loading = false
          this.loadingText = defaultLoadingText
        })
      },
      handleToUrlMenu(menu, id, row) {
        if (menu.mustSelectRow && !this.checkSelect(menu)) {
          return
        }
        if (menu.showConfirm) {
          this.$confirm(menu.confirmText || '您确定要执行此操作吗？', '确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.doToUrl(menu, id, row)
          }).catch((err) => {
            console.log(err)
          })
        } else {
          this.doToUrl(menu, id, row)
        }
      },
      doToUrl(menu, id, row) {
        let menuConfig = menu.extendMenuConfig ? JSON.parse(menu.extendMenuConfig) : ''
        this.hiddenFormAction = menuConfig.withBaseUrl ? (util.baseUrl + menu.url) : menu.url
        this.hiddenFormTarget = menu.openMode || '_blank'
        let ids = menu.showType === 'column' ? id : this.getIds(menu).join(',')
        this.hiddenFormParameters = []
        this.hiddenFormParameters.push({name: 'ids', value: ids})
        this.hiddenFormParameters.push({name: 'access_token', value: util.token()})
        if (menu.extraParameters) {
          for (let key in menu.extraParameters) {
            this.hiddenFormParameters.push({name: key, value: menu.extraParameters[key]})
          }
        }
        // 补充动态参数
        let rowParams = this.getMenuRowParams(menu, row)
        for (let key in rowParams) {
          this.hiddenFormParameters.push({name: key, value: rowParams[key]})
        }
        this.$nextTick(_ => {
          this.$refs.hiddenForm.submit()
        })
      },
      handleUpdateColumnMenu(menu, id) {
        if (menu.mustSelectRow && !this.checkSelect(menu)) {
          return
        }
        if (menu.showConfirm) {
          this.$confirm(menu.confirmText || '您确定要执行此操作吗？', '确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.doUpdateColumn(menu, id)
          }).catch((err) => {
            console.log(err)
          })
        } else {
          this.doUpdateColumn(menu, id)
        }
      },
      doUpdateColumn(menu, id) {
        let ids = menu.showType === 'column' ? id : this.getIds(menu).join(',')
        let url = this.updateColumnUrl
        let params = {}
        params.params = {
          ids: ids,
          actionId: this.gridConfig.gridId,
          column: menu.column,
          value: menu.value,
          ...this.params
        }
        if (this.selectAllRows) {
          params.page = {
            'curPage': this.page.curPage,
            'pageSize': this.page.pageSize,
            'orderItem': this.page.orderItem,
            'totalCount': this.page.totalCount
          }
          if (this.$refs.searchForm) {
            params.page.searchItem = this.processSearchParams()
          }
        }
        this.loading = true
        util.ajax.post(url, params).then((res) => {
          this.loading = false
          if (res.data.meta.errCode === 0) {
            this.$notify.success({title: '成功', message: res.data.data || '操作成功！'})
            this.loadTableData()
          } else {
            this.$notify.warning({title: '错误', message: res.data.meta.errMsg || '操作失败！'})
          }
        }).catch((err) => {
          console.error(err)
          this.$notify.error({title: '错误', message: '操作失败'})
          this.loading = false
        })
      },
      handleFormMenu(menu, id) {
        if (menu.mustSelectRow && !this.checkSelect(menu)) {
          return
        }
        let ids = menu.showType === 'column' ? id : this.getIds(menu).join(',')
        let extraParams = {
          ids: ids,
          ...this.params
        }
        if (menu.formConfig.requestConfig.extraParameters) {
          extraParams = {...extraParams, ...menu.formConfig.requestConfig.extraParameters}
        }
        let rootExtraParameters = {}
        if (this.selectAllRows) {
          rootExtraParameters.page = {
            'curPage': this.page.curPage,
            'pageSize': this.page.pageSize,
            'orderItem': [],
            'totalCount': this.page.totalCount
          }
          if (this.$refs.searchForm) {
            rootExtraParameters.page.searchItem = this.processSearchParams()
          }
        }
        this.initFormConfig(menu.formConfig.formTitle, menu.formConfig.requestConfig.url, menu.tips, extraParams, false, rootExtraParameters)
        menu.formConfig.formFieldList.map((item) => {
          this.formConfig.fields.push({
            uid: item.id || item.name,
            title: item.labelText,
            name: item.name,
            id: item.id || item.name,
            type: item.type,
            required: !item.nullable, // 是否必填
            checkRegular: item.checkRegular,
            checkMessage: item.checkMessage,
            canEdit: true,
            value: item.defaultValue,
            selectData: item.selectLocalData ? item.selectLocalData : null,
            selectDataUrl: item.selectDataUrl,
            checkboxAttributeList: item.checkboxAttributeList,
            placeholder: item.placeholder
          })
        })
        // 解析menuExtendConfig
        let menuExtendConfig = this.getMenuExtendConfig(menu)
        if (menuExtendConfig) {
          // 设置labelWidth
          if (menuExtendConfig.labelWidth) {
            this.formConfig.labelWidth = menuExtendConfig.labelWidth
          }
          if (menuExtendConfig.routerName) {
            this.formConfig.routerName = menuExtendConfig.routerName
          }
          if (menuExtendConfig.fieldName) {
            this.formConfig.fieldName = menuExtendConfig.fieldName
          }
        }
        this.$refs.gridEditDialogForm.show()
      },
      handleSimpleImportMenu(menu, id) {
        if (menu.mustSelectRow && !this.checkSelect(menu)) {
          return
        }
        let menuConfig = JSON.parse(menu.extendMenuConfig)
        // 导入模式
        let oldImportMode = menuConfig.oldImportMode
        if (!oldImportMode) { // 使用grid集成导入
          this.gridImportConfig = menuConfig.gridImportConfig
          // 如果没有配置读取excel的接口地址,则默认使用集成导入的
          if (!this.gridImportConfig.uploadUrl) {
            this.gridImportConfig.uploadUrl = this.uploadExcelUrl
          }
          // 添加额外的参数
          if (!this.gridImportConfig.startImportExtraParams) {
            this.gridImportConfig.startImportExtraParams = this.params
          } else {
            this.gridImportConfig.startImportExtraParams = {...this.gridImportConfig.startImportExtraParams, ...this.params}
          }
          this.$refs.gridImportRef.show()
        } else { // 使用simple-import导入,过时的
          this.importConfig = menuConfig.importConfig
          this.$refs.simpleImportRef.show()
        }
      },
      handleChangeRouterMenu(menu, id, row) {
        if (menu.mustSelectRow && !this.checkSelect(menu)) {
          return
        }
        let fieldName = 'ids'
        // 解析menuExtendConfig
        let menuExtendConfig = this.getMenuExtendConfig(menu)
        if (menuExtendConfig) {
          if (menuExtendConfig.fieldName) {
            fieldName = menuExtendConfig.fieldName
          }
        }
        if (!menuExtendConfig || !menuExtendConfig.routerName) {
          console.error('routerName未设置')
          return
        }
        let query = {}
        let fieldValue = menu.showType === 'top' ? this.getIds(menu).join(',') : id
        if (fieldValue) {
          query[fieldName] = fieldValue
        }
        // 获取extendConfig中的静态参数
        if (menuExtendConfig.params) {
          query = {...query, ...menuExtendConfig.params}
        }
        // 获取extendConfig中的动态参数
        query = {...query, ...this.getMenuRowParams(menu, row)}
        // 将query中的参数也放入query中,用于多级列表传参
        query = {...query, ...this.copyRoute.query}
        // 切换路由
        const router = {
          'name': menuExtendConfig.routerName,
          query: query
        }
        util.changeRouter(this, router)
      },
      handleBackMenu(menu, id) {
        util.routerBack(this)
      },
      handleMessageMenu(menu, id) {
        let message = menu.tips || ''
        this.$alert(message, {
          title: '说明信息',
          dangerouslyUseHTMLString: true
        })
      },
      getMenuRowParams(menu, row) { // 获取extendConfig中的动态参数
        let params = {}
        let menuExtendConfig = this.getMenuExtendConfig(menu)
        if (menuExtendConfig) {
          let rowParams = menuExtendConfig.rowParams
          if (rowParams) {
            for (let k in rowParams) {
              let rowKey = rowParams[k]
              try {
                if (menu.showType === 'top') {
                  let selectedRows = this.getSelectedRows()
                  let vArr = []
                  for (let i = 0; i < selectedRows.length; i++) {
                    vArr.push(util.getAttribute(selectedRows[i], rowKey))
                  }
                  params[k] = vArr.join(',')
                } else {
                  params[k] = util.getAttribute(row, rowKey)
                }
              } catch (e) {
                console.warn('获取参数失败：' + rowKey)
              }
            }
          }
        }
        return params
      },
      checkSelect(menu) {
        if (menu.showType === 'column') {
          return true
        }
        if (this.checkedRows.length <= 0) {
          this.$notify.info({title: '提示', message: '请至少先选中一个条目再执行操作！'})
          return false
        }
        if (menu.selectLimit !== 0 && this.checkedRows.length > menu.selectLimit) {
          this.$notify.info({title: '提示', message: '本次操作最多允许选择' + menu.selectLimit + '个条目！'})
          return false
        }
        return true
      },
      getIds(menu) {
        let dataIndex = menu.dataIndex || 'id'
        let ids = []
        if (menu.dataIndex === 'id') {
          ids = this.checkedRows
        } else {
          let selectedRows = this.getSelectedRows()
          for (let i = 0; i < selectedRows.length; i++) {
            ids.push(util.getAttribute(selectedRows[i], dataIndex))
          }
        }
        return ids
      },
      handleRowDblClick(rowId) {
        let title = '【' + this.gridConfig.title + '】修改'
        let extraParameters = {gridId: this.gridConfig.gridId, ...this.params}
        this.initFormConfig(title, this.updateUrl, '', extraParameters, true)
        this.initGridEditFormFields(true)
        this.abstractLoadDetail(rowId)
        if (this.gridConfig.addMode === 'drawer') {
          this.$refs.gridDrawerFormRef.show()
        } else {
          this.$refs.gridEditDialogForm.show()
        }
      },
      // 设置formConfig
      initFormConfig: function (title, url, tips, extraParameters, isBean, rootExtraParameters) {
        this.formConfig = {
          title: title,
          requestConfig: {
            url: url,
            extraParameters: extraParameters
          },
          tips: tips,
          isBean: isBean,
          fields: [],
          rootExtraParameters: rootExtraParameters
        }
      },
      // 初始化form的列
      initGridEditFormFields(isUpdate) {
        if (this.gridConfig.listColumnConfig && this.gridConfig.listColumnConfig.length > 0) {
          this.gridConfig.listColumnConfig.map((item) => {
            this.formConfig.fields.push({
              uid: item.uid,
              title: item.name,
              name: item.dataColumn || item.dataIndex,
              id: item.dataIndex_,
              sqlId: item.dataIndex,
              type: item.type,
              required: !item.allowBlank, // 是否必填
              maxLength: item.maxLength,
              checkRegular: item.checkRegular,
              checkMessage: item.checkMessage,
              canEdit: isUpdate ? item.update : item.add,
              cascadeColumns: item.cascadeColumns,
              dependColumns: item.dependColumns
            })
          })
        }
      },
      // 双击修改时加载数据并填充表单值
      abstractLoadDetail(id) {
        if (!id) {
          return
        }
        let params = {
          params: {
            actionId: this.gridConfig.gridId,
            gridUrl: this.myGridConfigUrl,
            ...this.params
          },
          page: {
            searchItem: {
              'id': '=' + id
            }
          }
        }
        let isSql = this.gridConfig.listType
        util.ajax.post(this.abstractDetailUrl, params).then((res) => {
          if (res.data.meta.errCode === 0) {
            let fieldValueMap = {}
            util.convertJsonToForm(res.data.data.items[0], fieldValueMap, '', this)
            this.formConfig.fields.map((field) => {
              if (isSql === '1') {
                let key = field.sqlId.substring(field.sqlId.lastIndexOf('.') + 1, field.sqlId.length)
                let value = fieldValueMap[key]
                if (typeof value === 'number' && field.type !== 'date' && field.type !== 'datetime') {
                  value = value + ''
                }
                this.$set(field, 'value', value)
              } else {
                let value = fieldValueMap[field.id]
                if (typeof value === 'number' && field.type !== 'date' && field.type !== 'datetime') {
                  value = value + ''
                }
                this.$set(field, 'value', value)
              }
            })
          }
        }).catch((e) => {
          console.error(e)
        })
      },
      handleAddButtonClick() {
        let title = '【' + this.gridConfig.title + '】添加'
        let extraParameters = {gridId: this.gridConfig.gridId, ...this.params}
        this.initFormConfig(title, this.abstractAddUrl, '', extraParameters, true)
        this.initGridEditFormFields()
        if (this.gridConfig.addMode === 'drawer') {
          this.$refs.gridDrawerFormRef.show()
        } else {
          this.$refs.gridEditDialogForm.show()
        }
      },
      handleDeleteButtonClick() {
        let rowChecks = this.checkedRows
        if (rowChecks === '' || rowChecks.length <= 0) {
          return
        }
        this.$confirm('此操作将永久删除所选数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {}
          params.params = {'actionId': this.gridConfig.gridId, 'ids': rowChecks.join(','), ...this.params}
          if (this.selectAllRows) {
            params.page = {
              'curPage': this.page.curPage,
              'pageSize': this.page.pageSize,
              'orderItem': [],
              'totalCount': this.page.totalCount
            }
            if (this.$refs.searchForm) {
              params.page.searchItem = this.processSearchParams()
            }
          }
          this.loading = true
          let defaultLoadingText = this.loadingText
          this.loadingText = '操作中，请稍后...'
          util.ajax.post(this.abstractDeleteUrl, params).then((res) => {
            this.loading = false
            this.loadingText = defaultLoadingText
            if (res.data.meta.errCode === 0) {
              this.$notify.success({title: '成功', message: res.data.meta.errMsg})
              this.loadTableData()
            } else {
              this.$notify.error({title: '错误', message: res.data.meta.errMsg})
            }
          }).catch((err) => {
            console.error(err)
            this.$notify.error({title: '错误', message: '操作失败'})
            this.loading = false
            this.loadingText = defaultLoadingText
          })
        }).catch(() => {
        })
      },
      // 点击导出按钮
      handleExport() {
        this.$refs.gridExportRef.show()
      },
      handleImport() { // 点击导入按钮
        // 初始化importConfig
        this.gridImportConfig = {
          title: '【' + this.gridConfig.title + '】导入',
          downloadImportTemplateUrl: this.downloadExcelTemplateUrl,
          downloadImportTemplateName: this.gridConfig.title + '.xls',
          uploadUrl: this.uploadExcelUrl,
          startImportExtraParams: this.params,
          startImportUrl: this.startImportExcelUrl,
          downloadErrorInfoUrl: this.downloadExcelErrorInfoUrl
        }
        this.$refs.gridImportRef.show()
      },
      handleImportFinish() { // 导入完成
        this.loadTableData()
      },
      handleAddSuccess() { // 添加成功后被调用
        this.$refs.gridEditDialogForm.hide()
        this.$refs.gridDrawerFormRef.hide()
        this.loadTableData()
      },
      handleChangeRouter: function (router) {
        this.$refs.gridEditDialogForm.hide()
        util.changeRouter(this, router)
      },
      handleSimpleImportClose() { // 简单导入框关闭事件
        this.importConfig = {}
      },
      getMenuExtendConfig(menu) {
        return (menu && menu.extendMenuConfig) ? JSON.parse(menu.extendMenuConfig) : {}
      },
      handleToggleChart() {
        this.showChart = !this.showChart
        this.$nextTick(this.computeHeight)
      },
      gridResizeListener() {
        let needCompute = false
        if (this.elOffsetHeight !== this.$el.offsetHeight) { // grid高度发生变化
          this.elOffsetHeight = this.$el.offsetHeight
          needCompute = true
        }
        if (this.showSearchForm && this.$refs.searchForm) {
          let searchFormHeight = this.$refs.searchForm.$el.offsetHeight
          if (this.elSearchFormHeight !== searchFormHeight) { // searchForm高度发生变化
            this.elSearchFormHeight = searchFormHeight
            needCompute = true
          }
        }
        if (this.$refs.topOperation) {
          let topOperationHeight = this.$refs.topOperation.$el.offsetHeight
          if (this.elToolbarHeight !== topOperationHeight) { // toolbar高度发生变化
            this.elToolbarHeight = topOperationHeight
            needCompute = true
          }
        }
        if (needCompute) {
          this.computeHeight()
        }
      },
      showChangeHistory: function(drawId, namespace, data) {
        this.historyDrawId = drawId
        this.historyNamespace = namespace
        this.historyDrawCurrentData = data
        this.historyVisible = true
      },
      closeChangeHistory: function() {
        this.historyVisible = false
        this.historyDrawId = null
        this.historyNamespace = null
        this.historyDrawCurrentData = null
      }
    },
    watch: {
      selectAllRows(newVal) {
        this.$refs.searchForm.showSearchMask = newVal
      },
      '$route' (to, from) {
        // 对路由变化作出响应...
        if (this.gridConfigUrl === to.meta.url && to.params.isBack) {
          this.loadTableData()
        }
      }
    }
  }
</script>
<style lang="scss">
  .grid-chart {
    .whaty-chart-wrapper {
      height: 80%;
      width: 80%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/grid/grid.vue